import { render, staticRenderFns } from "./LanguagesPreview.vue?vue&type=template&id=75db1ff4&"
import script from "./LanguagesPreview.vue?vue&type=script&lang=js&"
export * from "./LanguagesPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports